import { countries } from 'data/mock-data';

const mock = () => ({
  data: { countries },
});

export default mock;
